import { LOCALES, USER_PROFILE_URL } from '@snowball-tech/common/constants'

/*
 * ****************************************************************************
 * General constants
 * ****************************************************************************
 */

export * from '@snowball-tech/common/constants'

/*
 * ****************************************************************************
 * Authentication constants
 * ****************************************************************************
 */

const BASE_PROTECTED_PAGES = [USER_PROFILE_URL]
/** @public */
export const PROTECTED_PAGES = BASE_PROTECTED_PAGES.filter(Boolean)
LOCALES.forEach((locale) => {
  PROTECTED_PAGES.push(
    ...BASE_PROTECTED_PAGES.map((pathname) => `/${locale}${pathname}`),
  )
})
PROTECTED_PAGES.push(
  ...BASE_PROTECTED_PAGES.map((pathname) => `/:locale${pathname}`),
)
